import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  &:hover {\n    path {\n      fill: #03f5ae;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(StyleSvg, _object_spread_props(_object_spread({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.5 5.93774L3 11.9999L10.5 18.0621V12.9999H22V10.9999H10.5V5.93774Z",
            fill: "white"
        })
    }));
};
var StyleSvg = styled(Svg).withConfig({
    componentId: "sc-a78d1de1-0"
})(_templateObject());
export default Icon;
